import React, { useState, useEffect } from "react";
import axios from "axios";
import Api from "../Api/Api.json";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { parse, format } from "date-fns";
import { useQuery } from "@tanstack/react-query";
const TimeConverter = (dateTime24) => {
  const parsedDate = parse(dateTime24, "yyyy-MM-dd HH:mm:ss", new Date());
  const formattedTime = format(parsedDate, "MMMM dd, yyyy, hh:mm:ss a");

  return <div>{formattedTime}</div>;
};

const ReportsList = ({ patient_id }) => {
  //const prescription_list=[];
  const [pathology_list, setPathologyList] = useState([]);
  // const [radiology_list, setRadiologyList] = useState([]);

  const fetchData = async () => {
    const headers = { headers: { "Content-Type": "application/json" } };
    const url = Api.PATIENT_API;
    const requestData = {
      task: "getPatientDocumentsList",
      patient_id: patient_id,
    };

    try {
      const result = await axios.post(url, requestData, headers);
      return result.data;
    } catch (error) {
      return null;
    }
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["getPatientDocumentsList" + patient_id], // Unique key for this query
    queryFn: fetchData, // Function to fetch data
    staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
    cacheTime: 1000 * 60 * 10, // Cache data for 10 minutes
  });

  console.log(data);

  useEffect(() => {
    if (data && data.length > 0) {
      const arr = [];
      data[2].forEach((obj) => {
        arr.push({
          table_name: obj["table_name"],
          test_date: obj["document_date"],
          test_id: obj["report_id"],
        });
      });
      setPathologyList(arr);
    }
  }, [data]);

  const handleRecordClick = async (record) => {
    const headers = { headers: { "Content-Type": "application/json" } };
    const url = Api.PATIENT_API;
    const requestData = {
      task: "getPathologyReportHtmlString",
      patient_id: patient_id,
      test_date: record.test_date,
      test_id: record.test_id,
      table_name: record.table_name,
    };
    //console.log(requestData);
    axios
      .post(url, requestData, headers)
      .then((response) => {
        console.log(response.data);
        if (response.data.length > 0) {
          //htmlString+=response.data
          setPathologyList(
            pathology_list.map((item) => {
              if (item.test_id === record.test_id) {
                return {
                  ...item,
                  htmlString: response.data,
                };
              }
              return item;
            })
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const renderHTML = (htmlString) => {
    return { __html: htmlString };
  };
  return (
    <div
      className="overflow-y-auto p-2"
      style={{
        height: "calc(100vh - 239px)",
      }}
    >
      <div className="card">
        {pathology_list.length === 0 ? (
          <h3 className="text-lg font-semibold text-center">
            No Records Found
          </h3>
        ) : (
          <div>
            <h3 className="text-lg font-semibold text-center">
              List of Pathology Reports
            </h3>
            <ul>
              {pathology_list.map((item, index) => (
                <Accordion
                  key={index}
                  sx={{ mb: 1 }}
                  className="w-full"
                  onChange={() => handleRecordClick(item)}
                >
                  <AccordionSummary
                    expandIcon={
                      <IconButton>
                        <ExpandMore />
                      </IconButton>
                    }
                    aria-controls={`panel${index}-content`}
                    id={`panel${index}-header`}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <Box className="flex flex-col md:flex-row md:items-center md:gap-2">
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "medium" }}
                        >
                          {TimeConverter(item.test_date)}
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "medium" }}
                          className="hidden md:block"
                        >
                          -
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "medium" }}
                        >
                          {item.table_name}
                        </Typography>
                      </Box>
                    </Box>
                  </AccordionSummary>
                  <Divider />
                  <AccordionDetails>
                    <div className="html-report-container mb-2">
                      <div
                        dangerouslySetInnerHTML={renderHTML(item.htmlString)}
                        className="mb-2"
                      />
                    </div>
                  </AccordionDetails>
                </Accordion>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportsList;
